import React, { useEffect } from 'react';
import { useConfig } from '../hooks/useConfig';
import './AdBanner.css';

/**
 * AdBanner Component (FREE version only)
 * Displays banner ads via AdMob
 */
function AdBanner({ position = 'bottom' }) {
  const { config } = useConfig();

  const isAdsEnabled = () => {
    return config?.monetization?.enabled && 
           config.monetization.type === 'ads';
  };

  useEffect(() => {
    if (!isAdsEnabled()) return;

    // Show banner on mount
    if (window.AdMob) {
      window.AdMob.showBanner({
        adId: config.monetization.adUnits.banner,
        position: position === 'top' ? 'top' : 'bottom',
        isTesting: config.monetization.adConfig?.testMode || false
      }).catch(err => console.log('Banner error:', err));
    }

    // Hide banner on unmount
    return () => {
      if (window.AdMob) {
        window.AdMob.hideBanner().catch(() => {});
      }
    };
  }, [config, position]);

  // Don't render anything visible - AdMob injects native banner
  if (!isAdsEnabled()) {
    return null;
  }

  return (
    <div className={`ad-banner-placeholder ${position}`}>
      {/* AdMob banner appears here natively */}
    </div>
  );
}

export default AdBanner;